import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <p>&copy; {new Date().getFullYear()} Prodnook. Todos los derechos reservados.</p>
        <ul className="footer-links">
          <li>
            <Link to="/politicas">Políticas</Link>
          </li>
          <li>
            <Link to="/contacto">Contacto</Link>
          </li>
          <li>
            <Link to="/preguntas">Preguntas Frecuentes</Link>
          </li>
        </ul>
      </div>
    </footer>
  );
};

export default Footer;
